import React from 'react';
import Box from './box';

const WarningBox = props => <Box className="alert-warning" alignment={props.alignment}>
  {props.children}
</Box>;
export default WarningBox;
